export const dateObjects = [
  {
    id: 'reg',
    name: 'Дата регистрации',
  },
  {
    id: 'order',
    name: 'Дата заказа',
  },
  {
    id: 'payment',
    name: 'Дата платежа',
  },
  {
    id: 'web',
    name: 'Дата вебинара',
  },
  {
    id: 'ad',
    name: 'Дата рекламы',
  },
  // {
  //   id: "visit",
  //   name: "Дата посещения страницы",
  // },
];
export const displayObjects = [
  {
    id: 'table',
    name: 'Таблица',
  },
  {
    id: 'chart',
    name: 'Диаграмма',
  },
  {
    id: 'number',
    name: 'Показатель',
  },
];
